export default {
  driver_performance_events_assingStatus_status: "Status",
  driver_performance_events_assingStatus_selectStatus: "Select Status",
  driver_performance_events_assingStatus_title: "Set Status",
  driver_performance_events_assingStatus_success: "Status updated successfully",
  driver_performance_events_assingStatus_error: "Error updating status",
  driver_performance_changes_saved_successfully: "Changes saved successfully",
  driver_performance_comment_saved_successfully: "Comment saved successfully",
  driver_performance_error_saving: "Error saving changes",
  driver_performance_comments: "Comments",
  driver_performance_no_comments: "No comments yet",
  driver_performance_add_comment: "Add a comment",
};